import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '@/design-system/atoms/button/button.component';
import { IconComponent } from '@/design-system/atoms/icon/icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

export type BannerType = 'INFO' | 'WARN' | 'ERROR' | 'SUCCESS';

const ICON_SRC_BY_TYPE: Record<BannerType, string> = {
  INFO: 'icons/phosphor/regular/info.svg',
  WARN: 'icons/phosphor/regular/warning.svg',
  ERROR: 'icons/phosphor/regular/warning-circle.svg',
  SUCCESS: 'icons/phosphor/regular/check-circle.svg',
};

const MODIFIER_CLASS_BY_TYPE: Record<BannerType, string> = {
  INFO: 'banner--info',
  WARN: 'banner--warn',
  ERROR: 'banner--error',
  SUCCESS: 'banner--success',
};

@Component({
  selector: 'app-banner',
  imports: [IconComponent, ButtonComponent, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  type = input.required<BannerType>();
  title = input<string>();
  description = input<string>();
  dismissible = input(false);
  buttonLabel = input<string>();
  buttonLoading = input(false);

  dismissed = output();
  buttonClicked = output();

  protected readonly bannerClass = computed(() => `banner ${MODIFIER_CLASS_BY_TYPE[this.type()]}`);
  protected readonly iconSrc = computed(() => ICON_SRC_BY_TYPE[this.type()]);
  protected readonly ariaRole = computed(() =>
    this.type() === 'ERROR' || this.type() === 'WARN' ? 'alert' : 'status',
  );
}
